import { t as i18nT } from "i18next";
import { Trans } from "react-i18next";

function t(key: I18nKey): string;
function t(key: I18nKey, params: Keyable): React.ReactNode;
function t(key: I18nKey, params?: Keyable) {
  if (key.includes("plurals:")) return i18nT(key, params);
  if (params) {
    const values: Record<string, any> = {};
    const components: Record<string, any> = {};
    Object.entries(params).forEach(([key, value]) => {
      if (typeof value === "object") components[key] = value;
      else values[`value${key}`] = value;
      // if (!isNaN(Number(key))) values[`value${key}`] = value;
      // else components[key] = value;
    });
    return <Trans i18nKey={key as any} components={components} values={values} />;
  }
  return i18nT(key);
}
export { t };
